export default __webpack_public_path__ + "static/media/image-5.e84e3c4b.png";